module.exports = __webpack_public_path__ + "img/vpc_platform.b4b1449.png";